import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { treatmentFixedAssetControlNameConfig } from './TreatmentFixedAssetControl.name';

enum TreatmentFixedAssetControl {
  expenseProcessing = '1',
  noExpenseProcessing = '2',
  noExpenseProcessingIFRS = '3',
}

const treatmentFixedAssetControlMap = new Map([
  ['1', TreatmentFixedAssetControl.expenseProcessing],
  ['2', TreatmentFixedAssetControl.noExpenseProcessing],
  ['3', TreatmentFixedAssetControl.noExpenseProcessingIFRS],
]);

const rawValueToTreatmentFixedAssetControl = rawValueToEnumWithDefault(treatmentFixedAssetControlMap, '');
const rawValueToTreatmentFixedAssetControlWithDefault = rawValueToEnumWithDefault(
  treatmentFixedAssetControlMap,
  TreatmentFixedAssetControl.expenseProcessing,
);

const treatmentFixedAssetControlToDisplay = enumToNameWithDefault(
  TreatmentFixedAssetControl,
  treatmentFixedAssetControlNameConfig,
);

const treatmentFixedAssetControlToDisplayWithPrefix = enumToNameWithDefault(
  TreatmentFixedAssetControl,
  treatmentFixedAssetControlNameConfig,
  true,
);

export {
  TreatmentFixedAssetControl,
  rawValueToTreatmentFixedAssetControl,
  rawValueToTreatmentFixedAssetControlWithDefault,
  treatmentFixedAssetControlToDisplay,
  treatmentFixedAssetControlToDisplayWithPrefix,
};
